export const state = () => ({
  beneficiaries: [],
  quote: {},
})
